/**
 * Is this a phone-width viewport right now?
 *
 * Deliberately a WIDTH query, not `hover` or `pointer`. Those look like the
 * better question for "is this a touch device", and they are not reliable: a
 * Samsung handset reports hover capability, so a `(hover: none)` rule silently
 * never matches on exactly the hardware it was written for. Width is something
 * every browser reports correctly.
 *
 * 767px is one pixel below Tailwind's `md`, so this agrees with every `max-md:`
 * class in the app. Call it at the moment you need the answer rather than
 * caching it, so a rotation or a resize cannot leave a stale value behind.
 */
export function isNarrowViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}
